import { render } from "./Welcome.vue?vue&type=template&id=0682573c&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=0682573c&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-0682573c"

export default script